import * as React from 'react'
import * as ReactDOM from 'react-dom';
import IsaverQuoteRootComponent from './isaver-quote-root-component'
import './index.css';
import './styles/main.css'

// Embedly
(function(w:any, d:any){
var id='embedly-platform', n = 'script';
if (!d.getElementById(id)){
	w.embedly = w.embedly || function() {(w.embedly.q = w.embedly.q || []).push(arguments);};
	var e = d.createElement(n); e.id = id; e.async=1;
	e.src = ('https:' === document.location.protocol ? 'https' : 'http') + '://cdn.embedly.com/widgets/platform.js';
	var s = d.getElementsByTagName(n)[0];
	s.parentNode.insertBefore(e, s);
}
})(window, document);


// Google tag Manager script
(function (w, d, s, l, i) {
w[l] = w[l] || []; w[l].push({
	'gtm.start':
		new Date().getTime(), event: 'gtm.js'
}); var f = d.getElementsByTagName(s)[0],
	j:any = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
		'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-PX9SSHQ');


class GAComponent extends React.Component<any,any> {
	constructor(props) {
		super(props);
	  }

	iframe (props) {
	  return {
		__html: props.iframe
	  }
	}
  
	render () {
	  return (
		<div>
		  <div dangerouslySetInnerHTML={ this.iframe(this.props) } />
		</div>
	  );
	}
  }
  
const iframe = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PX9SSHQ" height="0" width="0" style="display:none;visibility:hidden"></iframe>'; 
  
ReactDOM.render(
	<div>
		<GAComponent iframe={iframe} />
        <IsaverQuoteRootComponent />
	</div>,
	
	document.getElementById('root') as HTMLElement
);


// Hot Reload
if (module["hot"]) {
    module["hot"].accept()
}

//Flex Chatbot
declare let window : any;
(function(d, m){ 
var kommunicateSettings = {"appId":"181ad3fdfeb9607e3315a39e91a45c1a0","popupWidget":true,"automaticChatOpenOnNavigation":true};
var s = document.createElement("script"); s.type = "text/javascript"; s.async = true;
s.src = "https://widget.kommunicate.io/v2/kommunicate.app";
var h = document.getElementsByTagName("head")[0]; h.appendChild(s);
window.kommunicate = m; m._globals = kommunicateSettings;
})(document, window.kommunicate || {});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/index.tsx